import React from "react";

function Refund() {
  return (
    <div className="container">
      <div className="row">
        <div className="poppins-black mt-3">REFUND POLICY:</div>
        <p className="pt-2">
          At proleverage.io, we want to ensure your satisfaction with our
          services. Please read this policy carefully to understand your rights
          and our obligations.
        </p>

        <div className="poppins-semibold mt-1" style={{ fontSize: "15px" }}>
          Free Trial
        </div>
        <p className="poppins-regular">
          We offer a 10 searches per day free trial of our service. Please note
          that Refunds given only when requested by email, by a registered user
          who has purchased less than 14 days prior, and has searched less than
          10 searches in a day. Absolutely NO exceptions! It takes 5 to 7
          working days to process refund & amount to be credited
        </p>

        <div className="poppins-semibold " style={{ fontSize: "15px" }}>
          Membership Cancellation
        </div>
        <p className="poppins-regular">
          You can cancel your membership anytime if you do not wish to continue.
          The cancellation process is simple and straightforward, ensuring no
          hassle for you.
        </p>

        <div className="poppins-semibold " style={{ fontSize: "15px" }}>
          Quality and Reliability
        </div>
        <p className="poppins-regular">
          We are committed to providing high-quality and reliable services. If
          you have any issues or concerns during your trial period, our support
          team is here to help.
        </p>
        <div className="poppins-regular">
          For any questions or assistance, please contact us at:
        </div>
        <ul>
          <li className="poppins-regular">
            Email: support@proleverage,io, support@ecomgyan.com
          </li>
          <li className="poppins-regular">Phone: 6364532840</li>
        </ul>
        <p className="poppins-regular">
          We value your feedback and are dedicated to ensuring you have a great
          experience with ProLeverage.io
        </p>
      </div>
    </div>
  );
}
export default Refund;
